<template>
  <div :class="['body',answerBool?'on':'']">
    <div v-if="!answerBool">
      <div class="questions-bg">
        <img class="bg" src="@a/measurement/questions_bg.png" alt="">
        <h2 class="title">个人能力测评</h2>
      </div>
      <!-- 测评答题组件 -->
      <div class="answer-questions">
        <!-- 选题模块 -->
        <div class="questions-container">
          <!-- 进度 -->
          <div v-if="!isPattern && !isTitle" class="questions-progress">
            <label>{{list[optionIndex]['optionCount']}}/{{questionCount}}</label>
            <div class="progress">
              <van-progress
                :percentage="percentage"
                :show-pivot="false"
                color="#EB5032"
                style="height:5px;border-radius:5px;"
              />
            </div>
          </div>
          <!-- 题目 -->
          <div v-if="!isPattern">
            <div v-for="(item,index) in list" :key="index" class="questions-title">
              <ul v-if="optionIndex==index">
                <li v-if="isArray(item.options).length>0" class="title">{{item.question}}</li>
                <li v-else v-for="(itm,idx) in strSplitArr(item.question)" :key="idx" :class="[`li${idx}`]">{{itm}}</li>
                <van-radio-group
                  v-if="isArray(item.options).length>0"
                  v-model="selectQuestionArray[index]"
                >
                  <van-radio
                    @click="selectQuestions(itemOption)"
                    :class="['radio',itemOption[1]==selectQuestionArray[index]?'on':false]"
                    v-for="(itemOption,indexOption) in isArray(item.options)"
                    :key="indexOption"
                    :name="itemOption[1]"
                  >{{itemOption[0]}}</van-radio>
                </van-radio-group>
              </ul>
            </div>
          </div>
          <!-- begin 他评 -->
          <div v-if="isPattern || isCompleteBool" class="he-review">
            <ul v-if="taTextObject">
              <li v-for="(item,index) in taTextObject.arr" :key="index" class="title" v-html="item"></li>
            </ul>
            <!-- begin 插入广告组件 -->
            <!-- <public-advertising v-if="isPattern && cid_type !='xuandui65'"></public-advertising> -->
            <!-- end插入广告组件 -->
          </div>

        </div>
        <!-- ACCA抽奖说明文字 -->
        <div v-if="!$route.query.ta_uid && ((isTitle && optionIndex>0) || (list[optionIndex]&& isArray(list[optionIndex].options).length==0))" class="acca-lucky-draw">
          测评结束后，ACCA将通过抽奖方式，送出50份一对一的测评报告专家解读的机会。先抽先得！
        </div>
        <!-- 下一步 -->
        <div v-if="(isTitle && optionIndex>0) || (list[optionIndex]&& isArray(list[optionIndex].options).length==0)" class="btn-group-on">
          <button
            v-if="isTitle && optionIndex>0"
            class="previousBtn-on"
            @click="previousHandle()"
          >上一题</button>
          <button
            v-if="list[optionIndex]&& isArray(list[optionIndex].options).length==0"
            class="nextBtn"
            :style="optionIndex==0?'margin-left:0;':''"
            @click="nextHandle()"
          >下一步</button>
        </div>
        <!-- 按钮 -->
        <div class="btn-group" v-if="(list[optionIndex] &&isArray(list[optionIndex].options).length>0 && optionIndex>0 && !isPattern) || isRepoer">
          <button
            v-if="list[optionIndex] &&isArray(list[optionIndex].options).length>0 && optionIndex>0 && !isPattern"
            class="previousBtn"
            @click="previousHandle()"
          >上一题</button>
          <!-- saveQuestionsHandle -->
          <button v-if="isRepoer" class="reportBtn" @click="informationHandle()">填写信息生成报告</button>
          
        </div>
        <!-- 答题页说明 -->
        <answer-sheet
          v-if="!$route.query.ta_uid"
          :class="['answer-sheet',!answerSheetShow?'on':'']"
          @answerBoolhandle="answerBoolhandle"
        ></answer-sheet>
        <public-explain @answerBoolhandle="answerBoolhandle" :class="['answer-sheet',!answerSheetShow?'on':'']" v-else></public-explain>
      </div>
    </div>
    <!-- 已答完题填写信息 -->
    <div v-else>
      <div class="questions-bg">
        <img class="bg" src="@a/measurement/questions_bg.png" alt="">
      </div>
      <!-- information -->
      <div class="inform">
        <h2>填写信息</h2>
        <h3>获取完整的能力报告及参与抽奖</h3>
        <!-- infor -->
        <div class="inform-group">
          <label >姓名:</label>
          <input type="text" v-model="infor.name" placeholder="请填写姓名" />
        </div>
        <!--  -->
        <div class="inform-group">
          <label >电话:</label>
          <input type="text" v-model="infor.phone"  placeholder="请填写电话" />
        </div>
        <!--  -->
        <div class="inform-group">
          <label >邮箱:</label>
          <input type="text" v-model="infor.email"  placeholder="请填写邮箱" />
        </div>
        <!--  -->
        <div class="inform-group">
          <label >学校:</label>
          <input type="text" v-model="infor.school"  placeholder="请填写学校" />
        </div>
        <!--  -->
        <div class="inform-group mt24">
          <label >专业:</label>
          <input type="text" v-model="infor.major"  placeholder="请填写专业" />
        </div>
        <!-- 是否已注册为ACCA学员 -->
        <div class="inform-group on">
          <label class="on" >是否已经注册成ACCA学员</label>
          <!-- radio -->
          <span @click="stuAccpState(1)">是</span>
          <img v-if="infor.state==1" class="inform-radio"  src="../../../assets/measurement/acca-stu.png" />
          <img v-else class="inform-radio" @click="stuAccpState(1)" src="../../../assets/measurement/no-acca-stu.png" />
          <span @click="stuAccpState(2)">否</span>
          <img v-if="infor.state==2" class="inform-radio"  src="../../../assets/measurement/acca-stu.png" />
          <img v-else class="inform-radio" @click="stuAccpState(2)" src="../../../assets/measurement/no-acca-stu.png" />
        </div>
        <!-- hr -->
        <div class="inform-hr"></div>
        <!-- 协议 -->
        <div class="agreement">
          <img v-if="boolAgre" class="radio-icon" src="../../../assets/measurement/acca-agreement-succ.png" />
          <img v-else class="radio-icon"  @click="boolAgreement(true)" src="../../../assets/measurement/acca-agreement.png" />
          通过填写此表并选中对话框， 表示我同意 ACCA 收集、使用、传输和分享我已输入的个人信息，并将其按照 ACCA 隐私声明处理我的信息并与我联系，发送关于行业新闻，活动，职业技巧和其他与 ACCA 资格或本人相关的资讯 如电子版 ACCA 注册指南(中文版)、附有注册指南的官方邮件，ACCA 月度出刊的电子杂志,以及可能与您相关的活动信息，还可能会接到来自 ACCA 及 ACCA 授权合作伙伴的电话咨询服务以帮助注册和学习 ACCA 。 您可以随时通过联系我们更新您的信息或选择取消订阅。ACCA 可能会与供应商和审核人员共享信息。对于非英国境内的人员，您的信息将会被存贮在 ACCA 位于欧盟的主要信息系统上，可能会被您的居住国/地区的 ACCA 当地办公室获取您的信息。 ACCA 主要在欧盟境内进行信息处理，但也可能由于其运营和服务交付的一部分需求，将数据传输到欧盟以外的地方。 有关如果尊重您的信息和权利的更多信息，请参阅我们的<span @click="privacyStatement=true">隐私声明</span>，或联系privacy@accaglobal.com。
        </div>
        <!-- hr -->
        <div class="inform-hr2"></div>
      </div>
      <!-- 查看报告 -->
      <a @click="checkReport()" class="save-questions">查看报告</a>
    </div>
    
    <!-- 继续答题 -->
    <van-popup  v-model="interruptShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2>是否从上次中断的位置继续答题？</h2>
            <div class="btn_group">
                <a class="confirm on" href="javascript:;" @click="isGetStorage(false)">重做</a>
                <a class="cancel" href="javascript:;" @click="isGetStorage(true)">继续答题</a>
            </div>
        </div>
    </van-popup>
    <!-- 隐私协议 -->
    <van-popup  v-model="privacyStatement" class="privacy-pop" :close-on-click-overlay="false">
        <img class="top-right-close" @click="privacyStatement=false" src="@a/measurement/close_top_right.png" />
        <div class="privacy-statement">
          <p class="on">ACCA关于隐私的承诺</p>
          <p class="on">本声明列明了您可期待的ACCA对您所交给信息的处理标准。</p>
          <p>您可期待的标准</p>
          <p><span>•</span>在您可以选择是否向我们提供您的信息或可以选择我们对信息的处理方式的情况下，我们会尽可能简化这一流程，方便您作出选择。</p>
          <p><span>•</span>我们始终会列出收集信息的原因，并且仅出于这些原因才使用信息。</p>
          <p><span>•</span>我们只收集和处理我们实际需要的信息。</p>
          <p><span>•</span>您的个人信息只有授权员工在履行职责需要这些信息时才能查看。</p>
          <p><span>•</span>不再需要的信息我们会予以删除，除非法律要求必须保留。如果我们不能删除信息，我们会明确说明这一点。</p>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { progress} from '@/api/measurement_system'
import { get_info,save_info} from '@/api/measurement'
import AnswerSheet from "./answer-sheet";
import PublicAdvertising from "./public-advertising";
import PublicExplain from "./explain";
import { getStorage, setStorage, deleteStorage} from '@/utils/tools'
import { phoneValidation,validateEmail } from '@/utils/validation'
export default {
  data() {
    return {
      selectQuestionArray: [],
      optionIndex: 0,
      answerSheetShow: true,
      questionCount:0,
      // 答题说明页数据
      sheetList: [],
      btnText:'',
      // 是否完成他评
      isCompleteBool:false,
      bool:true,
      // 定时更新测评进度
      ms_progress:null,
      // 存储答题进度
      ms_progress_index:null,
      // 是否答完题
      answerBool:false,
      //隐私协议
      privacyStatement:false,
      // 个人信息
      infor:{},
      // 是否同意协议
      boolAgre:false
    }
  },
  components: {
    AnswerSheet,
    PublicAdvertising,
    PublicExplain
  },
  computed: {
    /*
     *@param:
     *@return:
     *@Description: 把标题拆分，截取第一个句号
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020年5月6日
     */
    strSplitArr(){
      return (str)=>{
        let arr = [];
        if(str){
          arr = str.split('。')[0].split('：');
          arr.push(str.substring(str.indexOf('。')+1,str.length));
        }
        

        return arr;
      }
    },
    isTitle(){
       return  this.list && this.list[this.optionIndex] && this.isArray(this.list[this.optionIndex].options).length==0 
    },
    /*
     *@param:
     *@return:
     *@Description: 是否他评
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 15:04:35
     */
    isPattern() {
      if(this.list && this.list.length>0){
        let bool = this.optionIndex + 1 == this.list.length &&
          this.selectQuestionArray[this.optionIndex] && 
          this.pattern;
        // 如果他评完成
        if(bool){
          this.saveHeReviewHandle();
        }
        return bool
      }
      return true
    },
    /*
     *@param:
     *@return:
     *@Description: 是否答完最后一题
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 15:04:35
     */
    isRepoer() {
      if(this.list && this.list.length>0){
        return (
          this.optionIndex + 1 == this.list.length &&
          this.selectQuestionArray[this.optionIndex] && 
          !this.pattern
        )
      }
      return false;
    },
    /*
     *@param:
     *@return:
     *@Description: 计算百分比
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 18:08:31
     */
    percentage() {
      if(this.list && this.list.length>0){
       return this.optionIndex + 1 == this.list.length
        ? 100
        : (this.optionIndex / this.list.length) * 100;
      }
      return 0
        
    },
    /*
     *@param: arr
     *@return: arr || []
     *@Description: 判断当前是否是数组，如果不是则显示下一个并且返回空数组，否则返回数组
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 16:12:10
     */
    isArray() {
      return arr => (arr instanceof Array ? arr : []);
    }
  },
  /*
   *@param: list 数组对象，intro 测评答题说明文案，pattern 他评，ta_nickname 昵称
  */
  props: ['cid_type','data_','array','intro','pattern','taTextObject','interruptShow'],
  methods: {
    // 查看报告
    checkReport(){
      if(!this.infor || !this.infor.name || !this.infor.phone || !this.infor.email || !this.infor.school || !this.infor.major || !this.infor.state){
        this.$toast('信息不能空！');
        return
      }
      if(!phoneValidation(this.infor.phone)){
        this.$toast('手机号不正确！');
        return
      }
      if(!validateEmail(this.infor.email)){
        this.$toast('邮箱不正确！');
        return
      }
      if(!this.bool){
        this.$toast('请先同意隐私声明协议！');
        return
      }
      //调用加载中
      this.$emit('loadingHandle',true,"提交信息生成报告中...");
      save_info({
        cid:this.data_.cid,
        info:JSON.stringify(this.infor)
      }).then((data)=>{
        if (data.code == 10002) {
          this.$toast(data.msg);
          return
        }
        this.saveQuestionsHandle();
      });
    },
    // 同意协议
    boolAgreement(val){
      this.$forceUpdate();
      this.boolAgre = val;
    },
    // 点击切换状态
    stuAccpState(val){
      this.$forceUpdate();
      this.infor['state'] = val;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 答题完毕填写信息按钮触发
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020年5月6日
    */
    informationHandle(){
      this.answerBool = true;
      // 存储答题状态
      setStorage(this.$route.path,'answerState',this.answerBool);
      get_info({
        cid:this.data_.cid
      }).then((data)=>{
        if (data.code == 10002) {
          this.$toast(data.msg);
          return
        }
        if(data.info){
          this.infor = JSON.parse(data.info);
          this.boolAgre = true;
        }
        
      });
    },
    /*
     *@param: bool
     *@return: 
     *@Description: 监听开始答题按钮点击
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-04 09:57:05
    */
    answerBoolhandle(bool){
      this.answerSheetShow = bool;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 提交他评答题数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 11:36:56
    */
    saveHeReviewHandle(){
      let arr = [],
        count = 0;
      this.list.forEach((item, index) => {
        if (item.options && this.selectQuestionArray[index]) {
          this.$set(arr, count, {
            qid: item.id,
            eid: item.eid,
            cid: item.cid,
            score: this.selectQuestionArray[index]
          });
          count++;
        }
      });
      this.$emit("saveHeReview", arr);
    },
    /*
     *@return:函数 saveReportHandle，参数 arr
     *@Description: 提交答题结果生成报告
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 11:11:28
     */
    saveQuestionsHandle() {
      let arr = [],
        count = 0;
      this.list.forEach((item, index) => {
        if (item.options && this.selectQuestionArray[index]) {
          this.$set(arr, count, {
            qid: item.id,
            eid: item.eid,
            cid: item.cid,
            score: this.selectQuestionArray[index]
          });
          count++;
        }
      });
      this.$emit("saveReportHandle", arr);
      // 销毁定时器
      window.clearInterval(this.ms_progress);
    },
    /*
     *@param:
     *@return:
     *@Description: 选中答案
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 17:58:31
     */
    selectQuestions(selectArr) {
      if (this.selectQuestionArray[this.optionIndex] && this.bool) {
        this.bool=false;
        let item  = this.list[this.optionIndex];
        if(!this.pattern){
          // 存储答题缓存
          setStorage(this.$route.path,String(item.cid) + String(item.id),selectArr[1]);
        }
        // 当前下标小于数组总长度
        if(this.optionIndex + 1 < this.list.length){
          // 延时等待css效果执行
          setTimeout(()=> {
            // 数组的下标
            this.optionIndex++;
            this.bool = true;
          },600);
        } else {
          this.bool = true;
        }
        let is_complete = (this.optionIndex == this.list.length - 1) ? true : false;
        // 神策统计--选择选项时触发
        sensors.track('doQuestions', {
          evaluation_id: this.data_.cid,
          evaluation_name: this.data_.headtitle,
          questions_number: this.data_.progress += 1,
          questions_topic: item.question,
          questions_option: selectArr[0],
          is_complete_question: is_complete,
          share_user_id: this.$route.query.share_uid || "",
          channel_name: this.$route.query.channel || ""
        });
      }
    },
    /*
     *@param:
     *@return:
     *@Description: 下一步
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 17:04:35
     */
    nextHandle() {
      // 如果当前没有选中只有标题就给赋值为空字符串
      this.selectQuestionArray[this.optionIndex] = "";
      // 获得当前题目的对象
      let item  = this.list[this.optionIndex];
      // 存储答题缓存,如果是标题值就存  'title'
      setStorage(this.$route.path,String(item.cid) + String(item.id),'title');
      this.optionIndex++;
    },
    /*
     *@param:
     *@return:
     *@Description: 上一题
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 17:26:29
     */
    previousHandle() {
      this.optionIndex--;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 初始化方法
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 18:12:40
    */
    pullData(bool){
      let count = 1;
      let idx = 0;
      // 去掉无选项的标题，计算一共多少道题目
      this.list.forEach((item,index)=>{
        if(bool){
          if(getStorage(this.$route.path, String(item.cid) + String(item.id))){
            this.selectQuestionArray[index] = getStorage(this.$route.path, String(item.cid) + String(item.id));
          }
          if(item.options){
            if(getStorage(this.$route.path, String(item.cid) + String(item.id)) && getStorage(this.$route.path, String(item.cid) + String(item.id))!='title'){
              count++;
            }
          }
        }
        // 如果当前对象里的options数组不为null
        if(item.options){
          idx++;
          this.questionCount++;
        }
        item['optionCount'] = idx;
        
      });
      // 向父组件触发一个函数
      this.$emit("questionsProgress",{
        questionCount:this.questionCount,
        
      });
      // 答案值的数组长度是否为0
      let selectArr = this.selectQuestionArray.length;
      this.optionIndex = selectArr>0?(selectArr>=this.list.length-1?selectArr-1:selectArr):0;
      // 判断是否答完题
      this.answerBool = getStorage(this.$route.path,'answerState')!=undefined?getStorage(this.$route.path,'answerState'):false;
      if(this.answerBool){
        this.informationHandle();
      }
    },
    /*
     *@Description: 是否完成他评
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 12:03:25
    */
    isComplete(){
      this.answerSheetShow = false;
      this.isCompleteBool = true;
    },
    /*
     *@param: bool
     *@Description: 是否读取本地缓存
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 16:09:34
    */
    isGetStorage(bool){
      if(!bool){
        // 提交删除缓存 
        deleteStorage(this.$route.path);
      }
      this.pullData(bool);
      this.interruptShow = false;
      if(bool){
        this.answerSheetShow = false;
      }
    },
    /*
     *@Description: 测评答题说明页
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 16:28:24
    */
    sheetHandle(){
      // 测评答题说明页
      this.answerSheetShow = this.intro.length>0?true:false;

    },
    /*
      *@param: 
      *@return: 
      *@Description: 更新测评进度
      *@MethodAuthor:  Zhang Xiao Guang
      *@Date: 2019-12-16 17:41:33
    */
    msProgress(){
      let percentage = Math.round(this.percentage*10)/10;
      progress({
        cid:this.data_.cid,
        progress:percentage
      }).then(()=>{

      });
    }
  },
  destroyed(){
    // 销毁定时器
    window.clearInterval(this.ms_progress);
  },
  mounted(){
    this.ms_progress = window.setInterval(()=> {
      if(this.optionIndex>this.ms_progress_index){
        // 赋值答题进度
        this.ms_progress_index = this.optionIndex;
        this.msProgress();
      }
    },10000)
  },
  created(){
    this.list = !this.array?[]:this.array;
    if(this.data_ && String(this.data_.code)!=10002){
      // 重新答题或没有缓存
      if(!this.interruptShow){
        this.pullData();
      }
      this.sheetHandle();
    }else{
      if(this.pattern){
        this.isComplete();
        return false;
      }
      this.$toast(this.data.data.msg);
    }
  }
};
</script>

<style lang="scss" scoped>
.body{
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #E60012;
  z-index: 1;
}
.body.on{
  background-color: #f0f0f0;
}

.questions-bg{
  height: 360px;
  z-index: 2;
  img.bg{
    width: 100%;
    height: 360px;
    position:relative;
    z-index: 2;
  }
  h2.title{
    position: relative;
    z-index: 3;
    font-size: 60px;
    font-weight: bold;
    color: #ffffff;
    margin: -227px auto auto 57px;
  }
}

// 填写信息 begin
.inform{
  padding:53px 44px 40px;
  margin:-232px auto 40px;
  position: relative;
  z-index: 2;
  box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
  border-radius: 10px;
  background-color: #ffffff;
  width:700px;
  h2{
    font-size:42px;
    color:#E60012;
    text-align:center;
    font-weight:bold;
    line-height: 1;
    margin-bottom: 14px;
  }
  h3{
    font-size:30px;
    color:#E60012;
    text-align:center;
    font-weight:bold;
    line-height: 1;
    margin-bottom:58px;
  }
  .inform-group{
    display:flex;
    color:#333333;
    font-size:24px;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    
    label{
      font-weight: bold;
      margin-right: 20px;
      line-height: 1;
    }
    label.on{
      margin-right: 0;
    }
    input{
      line-height:60px;
      width:400px;
      border:none;
      border-radius:10px;
      background-color: #F0F0F0;
      padding: 0 20px;
      box-sizing: border-box;
      letter-spacing: 2px;
    }
    span{
      margin-right: 16px;
      margin-left: 25px;
      font-weight: bold;
    }
    .inform-radio{
      width: 30px;
      height: 30px;
    }
  }
  .inform-group.mt24{
    margin-bottom: 24px;
  }
  .inform-group.on{
    margin-bottom: 30px;
  }
  .inform-hr{
    height: 2px;
    background-color: #C0C0C0;
    width: 100%;
    margin-bottom: 20px;
  }
  .inform-hr2{
    height: 2px;
    background-color: #C0C0C0;
    width: 100%;
    margin-top: 20px;
  }
  .agreement{
    text-align: justify;
    font-size: 18px;
    color: #888888;
    line-height:25px;
    .radio-icon{
      width:30px;
      height:30px;
      margin: 0 10px 0 14px;
      
    }
    span{
      color: #0A25EB;
      text-decoration: underline;
    }
  }
}
.save-questions{
  display: block;
  width: 470px;
  line-height: 80px;
  background-color: #E60012;
  color: #ffffff;
  font-size: 30px;
  margin: 0 auto 60px;
  border-radius: 40px;
  text-align: center;
}
//填写信息 end


.answer-questions {
  margin-top: -95px;
  padding: 0px 30px 90px;
  text-align: center;
  position: relative;
  z-index: 3;
  // 弹出开始测评说明
  .answer-sheet {
    transition: all 2s;
    position: fixed;
    z-index: 998;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    max-width: 750px;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .answer-sheet.on {
    left: -750px;
  }
  .questions-container {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 10px;
    padding: 35px 30px;
    background-color: #ffffff;
    // min-height: 800px;
    position: relative;
    .questions-progress {
      padding-bottom: 35px;
      border-bottom: 2px solid #f0f0f0;
      display: flex;
      align-items: center;
      label {
        font-size: 32px;
        color: #eb5032;
      }
      .progress {
        margin-left: auto;
        flex: 1;
        border-radius: 5px;
        overflow: hidden;
        margin-left: 30px;
      }
    }
    .questions-title {
      color: #333333;
      text-align: left;
      .title {
        font-size: 36px;
        font-weight: bold;
        margin: 40px auto 100px;
      }
      .li0{
        padding:33px 0 18px;
        font-size:30px;
        text-align: center;
      }
      .li1{
        margin-bottom:147px;
        font-weight: bold;
        font-size:60px;
        text-align: center;
        letter-spacing:1px;
      }
      .li2{
        font-size: 30px;
        text-align: justify;
        margin: 0px auto 100px;
        line-height:48px;
      }
      .radio {
        display: flex;
        margin-bottom: 55px;
        font-size: 32px;
        line-height: 46px;
        .van-icon.van-icon-success {
          background-color: #eb5032;
          border-color: #eb5032;
          &::before {
            content: "";
          }
        }
      }
    }
    
    
    .he-review{
      font-size: 36px;
      text-align: left;
      ul li{
        margin-bottom: 30px;
      }
    }
  }
  .acca-lucky-draw{
    font-size:42px;
    color:#FFFFFF;
    background-color:#08151B;
    border-radius:10px;
    padding:50px 30px;
    text-align: justify;
    margin-top: 40px;
    line-height:60px;
  }
  .btn-group-on{
    margin:70px auto 0;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .nextBtn {
      line-height: 80px;
      height: 80px;
      color: #333333;
      background: #ffffff;
      border: none;
      width: 260px;
      font-size: 32px;
      margin-left: auto;
      border-radius: 40px;
    }
    .previousBtn-on {
      line-height: 80px;
      height: 80px;
      color: #333333;
      background: #ffffff;
      border: 2px solid #eb5032;
      width: 260px;
      font-size: 32px;
      border-radius: 40px;
    }
  }
  .btn-group{
    margin:70px auto 0;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .reportBtn{
      line-height: 80px;
      height: 80px;
      margin-left: auto;
      width: 348px;
      color: #333333;
      background: #ffffff;
      border: none;
      font-size: 32px;
      border-radius: 40px;
    }
    .previousBtn{
      line-height: 80px;
      height: 80px;
      width: 260px;
      color: #333333;
      background: #ffffff;
      border: 2px solid #eb5032;
      font-size: 32px;
      border-radius: 40px;
    }
  }
  .confirm_box {
    h2 {
      padding: 40px 30px;
    }
    h2.on{
      padding: 60px 30px;
    }
    p {
      margin-bottom: 50px;
      font-size: 26px;
      color: #666;
    }
    .btn_group {
      .confirm{
        color: #999999;
      }
      .cancel{
        color:#EB5032;
      }
    }
  }
}
.privacy-statement{
  padding:30px 40px;
  border-radius:30px;
  background-color:#fff;
  width:590px;
  p{
    font-size:24px;
    color:#333333;
    line-height:44px;
    text-align:justify;
    span{
      margin-right:30px;
      display: inline-block;
      vertical-align: initial;
    }
  }
  p.on{
    margin-bottom:52px;
  }
}
.privacy-pop{
  background-color:transparent;
  padding-top:70px;
  .top-right-close{
    width:52px;
    height:70px;
    position: absolute;
    right: 60px;
    top:0;
  }
}
</style> 

<style lang="scss">
body {
  background: #ffffff;
}
.answer-questions .questions-title .radio.on{
  transition: all .5s;
  .van-radio__label{
    color:#eb5032;
    font-weight: bold;
  }
}
.answer-questions .questions-title .radio {
  display: flex;
  margin-bottom: 53px;
  .van-radio__icon .van-icon {
    margin-top: 6px;
    width: 30px;
    height: 30px;
  }
  .van-radio__label{
    line-height: 46px;
  }
  .van-radio__icon--checked .van-icon.van-icon-success {
    background-color: #eb5032;
    border-color: #eb5032;
    &::before {
      content: "";
    }
  }
}
</style>